import { FC } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import footer from '@config/footer/section-links.json'
import { Grid } from '@mui/material'

export interface ILink {
  name: string
  href: string
  type?: string
}

export interface IFooter {
  footNote: {
    label: string
    primaryLinks: ILink[]
    secondaryLinks: ILink[]
  }
}

const footerData: IFooter = footer.data
const { footNote } = footerData

const AdminFooter: FC = () => {
  return (
    <Box
      component={'footer'}
      py={2}
      sx={({ ues, shadows }) => ({
        borderTop: `1px solid ${ues.neutral['20']}`,
        background: ues.neutral['0'],
        boxShadow: shadows[4],
        px: {
          xs: 2,
          sm: 2,
          md: 10.5,
          lg: 10.5,
        },
        height: 40,
      })}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Grid container spacing={{ md: 2, lg: 0 }}>
          <Grid item xs={12} md={12} lg={12}>
            <Box
              sx={{
                flexDirection: { xs: 'column', sm: 'column', md: ' row' },
                gap: { xs: 1, sm: 1, md: 2, lg: 3 },
                display: 'flex',
              }}
            >
              <Typography
                noWrap
                variant={'body2'}
                pt={1}
                mb={{ xs: 2, sm: 2, md: 0, lg: 0, xl: 0 }}
              >
                {footNote.label}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default AdminFooter
